export default __webpack_public_path__ + "fb2373bddc22bbe54c339ec37aeadde4.png";